import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 415,
  name: 'Unsupported Media Type',
  description:
    'The server refuses the request because the Content-Type header specifies a media type that the endpoint does not support. The payload format is not one the server is willing to accept.',
  causes: [
    'Sending JSON to an endpoint that expects form data (application/x-www-form-urlencoded), or vice versa.',
    'Missing Content-Type header entirely. Some frameworks default to a type the endpoint does not accept.',
    'Uploading a file type the server does not support (e.g., sending a .webp image to an endpoint that only accepts .jpg and .png).',
  ],
  fixes: [
    'Set the correct Content-Type header: application/json for JSON, multipart/form-data for file uploads, application/x-www-form-urlencoded for form data.',
    'Check the API documentation for accepted media types. The response may include an Accept header listing supported types.',
    'If using fetch or axios, ensure the Content-Type is not being overridden by default settings or interceptors.',
  ],
  monitoringTip:
    'A 415 on a previously working endpoint usually means a deployment changed the accepted content types. Uptrack monitors response codes so you catch these breaking changes quickly.',
}

export const Route = createFileRoute('/_site/http/415')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
